<template>
  <a-card :bordered="false">
    <!-- 顶部筛选区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="8" :sm="24">
            <a-form-item label="物流单号">
              <a-input v-model.trim="queryParam.logisticsNo" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <a-col :md="8" :sm="24">
            <a-form-item label="车号">
              <a-input v-model.trim="queryParam.vehicleNo" placeholder="请输入" />
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="8" :sm="24">
              <a-form-item
                label="创建时间"
                :labelCol="{lg: {span: 7}, sm: {span: 7}}"
                :wrapperCol="{lg: {span: 10}, sm: {span: 17} }"
              >
                <a-range-picker
                  v-model="queryParam.time"
                  style="width: 100%"
                  :disabledDate="disabledDate"
                  :ranges="{ '今天': [moment().startOf('day'), moment().endOf('day')], '本月': [moment().startOf('month'), moment().endOf('day')] }"
                  showTime
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="业务类型">
                <a-select
                  v-model="queryParam.businessTypeId"
                  default-value="0"
                  @change="businessTypeSelectChange"
                  placeholder="请选择"
                >
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in businessTypeSelect"
                    :key="index"
                    :value="item.id"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="8" :sm="24">
              <a-form-item label="物流状态">
                <a-select v-model="queryParam.status" default-value="0" placeholder="请选择">
                  <a-select-option value>全选</a-select-option>
                  <a-select-option
                    v-for="(item, index) in statusSelect"
                    :key="index"
                    :value="item.value"
                  >{{ item.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="!advanced && 8 || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="advanced && { float: 'right', overflow: 'hidden' } || {} "
            >
              <a-button type="primary" @click="$refs.table.refresh(true)">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => {queryParam = {}; this.statusSelect = null}"
              >重置</a-button>
              <a @click="toggleAdvanced" style="margin-left: 8px">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- 上部功能导航 -->
    <div class="table-operator">
      <a-button
        type="dashed"
        v-if="config.hasAlert"
        @click="tableOption"
      >{{ optionAlertShow && '关闭' || '开启' }} alert</a-button>
    </div>

    <!-- 数据网格 -->
    <s-table
      ref="table"
      size="default"
      :bordered="config.globlaBordered"
      :rowKey="(record) => record.id"
      :columns="columns"
      :data="loadData"
      :scroll="{ x: 1200 }"
      :alert="options.alert"
      :rowSelection="options.rowSelection"
      :pagination="{pageSizeOptions:pageSizeOptionsList,showTotal:total => `共${total}条`}"
    >
      <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
      <span slot="action" slot-scope="text, record">
        <a @click="handleDetail(record)">详情</a>
      </span>
    </s-table>
  </a-card>
</template>

<script>
import { PageView } from '@/layouts'
import { STable } from '@/components'
import { codeList } from '@/api/sys'
import { logisticsLogPage, logisticsLogDelete } from '@/api/logistics'
import { formatDate } from '@/utils/date'
import moment from 'moment'
import { businessTypeList } from '@/api/basic'
import storage from '@/utils/storage'
import queryMixin from '@/mixins/queryMixin'

export default {
  name: 'LogisticsLog',
  mixins: [queryMixin],
  components: {
    PageView,
    STable
  },
  data() {
    return {
      pageSizeOptionsList:['10'],
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: null,
      // 表头
      columns: [
        {
          title: '物流单号',
          dataIndex: 'logisticsNo',
          width: '200px',
          fixed: 'left'
        },
        {
          title: '车号',
          dataIndex: 'vehicleNo',
          width: '180px'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          width: '200px',
          customRender: text => {
            let date = new Date(text)
            return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
          }
        },
        {
          title: '业务类型',
          dataIndex: 'businessTypeName',
          width: '100px'
        },
        {
          title: '物流状态',
          dataIndex: 'statusName',
          width: '140px'
        },
        {
          title: '请求参数',
          dataIndex: 'parameters',
          width: '200px'
        },
        {
          title: '备注',
          dataIndex: 'remark',
          width: '160px'
        },
        {
          title: '操作',
          width: '50px',
          fixed: 'right',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' }
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        // 日期处理
        if (this.queryParam.time !== undefined && this.queryParam.time.length > 1) {
          this.queryParam['startTime'] = formatDate(new Date(this.queryParam.time[0]), 'yyyy-MM-dd hh:mm:ss')
          this.queryParam['endTime'] = formatDate(new Date(this.queryParam.time[1]), 'yyyy-MM-dd hh:mm:ss')
        } else {
          this.queryParam['startTime'] = null
          this.queryParam['endTime'] = null
        }

        return logisticsLogPage(Object.assign(parameter, this.queryParam)).then(res => {
          return res.data
        })
      },

      selectedRowKeys: [],
      selectedRows: [],

      // 业务类型
      businessTypeSelect: null,
      // 物流单状态
      statusSelect: null,

      // custom table alert & rowSelection
      options: {
        alert: {
          show: false,
          clear: () => {
            this.selectedRowKeys = []
          }
        },
        rowSelection: {
          selectedRowKeys: this.selectedRowKeys,
          onChange: this.onSelectChange
        }
      },
      optionAlertShow: true
    }
  },
  created() {
    this.tableOption()
    this.loadSelectData()
    console.log(this.queryParam)
    // 初始化查询条件
    if (!this.queryParam){
      this.queryParam =  {time:[moment().startOf('day'), moment().endOf('day')]}
    }else{
      if (this.queryParam.time.length >0){
        this.queryParam.time[0] = moment(this.queryParam.time[0])
        this.queryParam.time[1] = moment(this.queryParam.time[1])
      }
    }
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days before today and today
      return current && current > moment().endOf('day')
    },
    loadSelectData() {
      // 从后台拉取下拉列表数据
      new Promise(resolve => {
        const data = businessTypeList().then(res => {
          return res.data
        })
        resolve(data)
      }).then(res => {
        this.businessTypeSelect = res
      })
    },
    businessTypeSelectChange(value) {
      if(value) {
        if (this.queryParam.status) {
          this.queryParam.status = ''
        }
      }
      for (let i = 0; i < this.businessTypeSelect.length; i++) {
        if (this.businessTypeSelect[i].id === value) {
          new Promise(resolve => {
            const data = codeList({ typeCode: this.businessTypeSelect[i].nodeTypeId }).then(res => {
              return res.data
            })
            resolve(data)
          }).then(res => {
            this.statusSelect = res
          })
        }
      }
    },
    tableOption() {
      if (!this.optionAlertShow) {
        this.options = {
          alert: {
            show: false,
            clear: () => {
              this.selectedRowKeys = []
            }
          },
          rowSelection: {
            selectedRowKeys: this.selectedRowKeys,
            onChange: this.onSelectChange
          }
        }
        this.optionAlertShow = true
      } else {
        this.options = {
          alert: false,
          rowSelection: null
        }
        this.optionAlertShow = false
      }
    },
    handleDetail(record) {
      storage.save('cache-logisticsLogDetail', JSON.stringify(record))
      this.$router.push({ name: 'logisticsLogDetail' })
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys
      this.selectedRows = selectedRows
    },
    toggleAdvanced() {
      this.advanced = !this.advanced
    }
  },
  computed: {
    title() {
      return this.$route.meta.title
    }
  }
}
</script>
